import i18n from '@/lang'
import { getCurrentExercises } from '@/api/patient/currentExercises.js'
import { isSameRound, handleMergeExerciseAndConfig } from '@/util/helper'

const getDefaultState = () => (
  {
    id: '',
    scheduleId: '',
    loadedTime: 0,
    // isStart: false,
    current: {
      exercise: [],
      rehabInfos: [],
      exercisesWithConfig: [],
      level: 0,
      sameRound: false,
      date: 0,
      target: []
    },
    adjust: {
      exercise: [],
      rehabInfos: [],
      exercisesWithConfig: [],
      level: 0,
      sameRound: true,
      date: 0,
      status: i18n.t('status.notPublished'),
      submitTime: 0,
      target: []
    },
    target: {
      flexion: 0,
      extension: 0
    }
  }
)

const state = getDefaultState()

const getters = {
  getCurrentExercises: state => {
    return state.current
  },
  getAdjustExercises: state => {
    return state.adjust
  },
  getTarget: state => {
    return state.target
  },
  getLoadedTime: state => {
    return state.loadedTime
  },
  getLoadedId: state => {
    return state.id
  }
}

const mutations = {
  SET_PATIENT_ID: (state, patientId) => {
    state.id = patientId
  },
  SET_SCHEDULE_ID: (state, scheduleId) => {
    state.scheduleId = scheduleId
  },
  SET_LOADED_TIME: (state, loadedTime) => {
    state.loadedTime = loadedTime
  },
  SET_TARGET: (state, target) => {
    state.target = target
  },
  SET_CURRENT_EXERCISES: (state, current) => {
    state.current = current
  },
  SET_ADJUST_EXERCISES: (state, adjust) => {
    state.adjust = adjust
  },
  SET_EXERCISES_RELOAD (state, id) {
    if (state.id === id) {
      state.loadedTime = 0
    }
  },
  // 重置 state
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  // get template list
  setExercises ({ commit }, patientId = '') {
    return new Promise((resolve, reject) => {
      getCurrentExercises(patientId)
        .then(response => {
          const { data = [] } = response
          const { current, adjust, scheduleId, target } = data

          commit('SET_PATIENT_ID', patientId)
          commit('SET_SCHEDULE_ID', scheduleId)
          commit('SET_TARGET', target)
          commit('SET_LOADED_TIME', new Date().getTime())

          // NOTE: 設置進行中的動作
          if (current) {
            commit('SET_CURRENT_EXERCISES', {
              // 原始動作
              exercise: current.exercisesTmp,
              // 調整的動作參數
              rehabInfos: current.rehabInfos,
              // 合併動作參數後的動作
              exercisesWithConfig: handleMergeExerciseAndConfig(current.exercisesTmp, current.rehabInfos),
              level: current.level || 0,
              sameRound: isSameRound(current.exercisesTmp),
              date: current.publishTime,
              target: current.targets || []
            })
          } else {
            commit('SET_CURRENT_EXERCISES', getDefaultState().current)
          }

          // NOTE: 設置調整的動作
          if (adjust) {
            commit('SET_ADJUST_EXERCISES', {
              // 原始動作
              exercise: adjust.exercisesTmp,
              // 調整的動作參數
              rehabInfos: adjust.rehabInfos,
              // 合併動作參數後的動作
              exercisesWithConfig: handleMergeExerciseAndConfig(adjust.exercisesTmp, adjust.rehabInfos),
              level: adjust.level || 0,
              sameRound: isSameRound(adjust.exercisesTmp),
              date: adjust.publishTime || null,
              status: i18n.t('status.notPublished'),
              submitTime: adjust.submitTime,
              target: adjust.targets || []
            })
          } else {
            commit('SET_ADJUST_EXERCISES', getDefaultState().adjust)
          }

          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/modules/dailyExercise.js